import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {HydraService} from '../../../core/services/hydra.service';
import {ToolsService} from '../../services/tools/tools.service';
import {ModalTaskCreateComponent} from '../modal-task-create/modal-task-create.component';
import {api} from '../../../api/api-dictionnary';

import { MatButton } from '@angular/material/button';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatCard, MatCardContent } from '@angular/material/card';
import { TasksListComponent } from '../tasks-list/tasks-list.component';
import { LogComponent } from '../log/log.component';

export interface DashboardTaskWording{
    creationButtonLabel?: string;
}

@Component({
    selector: 'app-shared-dashboard-tasks',
    templateUrl: './dashboard-tasks.component.html',
    styleUrls: ['./dashboard-tasks.component.scss'],
    imports: [MatButton, MatTabGroup, MatTab, MatCard, MatCardContent, TasksListComponent, LogComponent]
})
export class DashboardTasksComponent {
    dialog = inject(MatDialog);
    hydraService = inject(HydraService);
    toolService = inject(ToolsService);


    @Input() action: string;
    @Input() target: string;
    @Input() title: string;
    @Input() version = 0;
    @Input() canCreateTasks = false;
    @Input() wording?: DashboardTaskWording;
    @Output() taskCreated = new EventEmitter<unknown>();



    public createTask() {
        this.dialog.open(ModalTaskCreateComponent, {
            panelClass: 'arc-dialog-panel',
            backdropClass: 'arc-dialog-backdrop',
            width: '840px'

        }).afterClosed().subscribe(res => {
            if (!res) {
                return;
            }

            const data = {
                data: {titre: res.titre, message: res.message},
                weight: res.weight,
                target: this.target,
            };

            this.hydraService.post(api.activities + '/create_task', data)
                .subscribe(activity => {
                        this.taskCreated.emit(activity);
                        this.toolService.notificationSuccess('✔ Tâche ajoutée !', 2000);
                        this.version++;
                    }
                );

        });
    }

}
